import api from "lib/axios";
import type { ApiEnvelope } from "services/apiTypes";
import { unwrapData } from "services/apiTypes";

export type QuizQuestionType = "true_false" | "single_choice" | "multiple_choice";

export type QuizQuestionOption = {
  answer: string;
  is_correct: boolean;
};

export type QuizQuestion = {
  id: number;
  quiz_id?: number;
  question: string;
  type: QuizQuestionType;
  score: number;
  options: QuizQuestionOption[];
  created_at?: string;
  updated_at?: string;
};

export type QuizQuestionUpsertBody = {
  question: string;
  type: QuizQuestionType;
  score: number;
  options: QuizQuestionOption[];
};

export const instructorQuizQuestionsService = {
  async create(courseId: number | string, quizId: number | string, body: QuizQuestionUpsertBody) {
    const res = await api.post<ApiEnvelope<{ data: QuizQuestion }>>(
      `/instructors/courses/${courseId}/quizzes/${quizId}/questions`,
      body
    );
    return unwrapData(res.data);
  },

  async update(courseId: number | string, quizId: number | string, questionId: number | string, body: QuizQuestionUpsertBody) {
    const res = await api.put<ApiEnvelope<{ data: QuizQuestion }>>(
      `/instructors/courses/${courseId}/quizzes/${quizId}/questions/${questionId}`,
      body
    );
    return unwrapData(res.data);
  },

  async remove(courseId: number | string, quizId: number | string, questionId: number | string) {
    const res = await api.delete<ApiEnvelope<unknown>>(
      `/instructors/courses/${courseId}/quizzes/${quizId}/questions/${questionId}`
    );
    return { message: (res.data as any)?.message ?? "Deleted." };
  },
};

